import { DotLegalOverflowMenuItem } from "@dotlegal/dotlegal-ui-components";
import { getAiOverflowMenuItem } from "../aiOverflowMenuItem.ts";

export function getContractAiUpdateOverflowMenuItem(
    onClick: () => void,
    blockedTranslationKey: string | undefined,
    translateString: (key: string) => string,
    disabledTranslationKey?: string
): DotLegalOverflowMenuItem {
    const blockedTooltip = blockedTranslationKey === undefined ? undefined : translateString(blockedTranslationKey);
    const disabledTooltip = disabledTranslationKey === undefined ? undefined : translateString(disabledTranslationKey);
    return getAiOverflowMenuItem(onClick, "aiAssistedUpdate", "aiAssistedUpdateDescription", blockedTooltip, translateString, disabledTooltip);
}
